import React from 'react';
import { Control, Controller, FieldErrors, FieldValues, Path } from 'react-hook-form';
import './GeneralInput.css';
import { useTranslation } from 'react-i18next';

interface Props<TFieldValues extends FieldValues = FieldValues> {
  label: string;
  name: Path<TFieldValues> | string;
  type: string;
  placeholder: string;
  control?: Control<TFieldValues>;
  errors?: FieldErrors<TFieldValues>;
  required?: boolean;
  dfvalue?: any;
  disabled?: boolean;
  handleChange?: (e: any) => void;
  autoComplete?: string;
  htmlName?: string;
}

const GeneralInput = <TFieldValues extends FieldValues = FieldValues>(props: Props<TFieldValues>) => {
  const { i18n } = useTranslation();

  const { label, name, type, placeholder, control, errors, required, dfvalue, disabled, autoComplete = 'off', htmlName } = props;

  const isError = !!errors?.[name as keyof typeof errors];
  const inputId = htmlName ?? name;

  return (
    <div className={type === 'checkbox' ? 'giWrap isCheckbox checkboxdiv' : 'giWrap'}>
      <label htmlFor={inputId} className={`giLabel ${isError ? 'isError' : ''}`}>
        {label}
      </label>

      <Controller
        rules={{ required }}
        name={name as Path<TFieldValues>}
        control={control}
        render={({ field: { value, onChange } }) => {
          const finalValue = disabled ? (value == null ? (dfvalue ?? '') : value) : (value ?? '');

          return (
            <input
              id={inputId}
              name={inputId}
              type={type}
              className={`giInput ${type === 'checkbox' ? 'isCheckbox ' : ''} ${isError ? 'isError' : ''}`}
              value={type === 'checkbox' ? undefined : finalValue}
              checked={type === 'checkbox' ? !!value : undefined}
              disabled={disabled}
              placeholder={placeholder}
              onChange={onChange}
              aria-invalid={isError || undefined}
              autoComplete={autoComplete}
              autoCorrect="off"
              autoCapitalize="none"
              spellCheck={false}
            />
          );
        }}
      />

      {isError && <p className="giErrorText">{i18n.t('generic.fieldRequired')}</p>}
    </div>
  );
};

export default GeneralInput;
